<template>
 <scroll-page :pull-reload="true">

   <page-padding v-if="computeUserAccess">
      <button-action  :to="'/calendar/'+cal_id+'/add_item/'" title="language.add_calendar_item" ></button-action>
   </page-padding>
 
    <list-calendar :cal_id="cal_id"/>
  
   </scroll-page>
</template>

<script>

import { mapState } from 'vuex';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import PagePadding from '../components/PagePadding.vue';
import ListCalendar from '../components/calendar/ListCalendar';
import ScrollPage from '../components/ScrollPage.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';


export default {
  name: 'group-calendar-page',
  data:function(){
    return{
      id:this.$route.params.id, // the group id
      cal_id:0,
    }
  },
  computed:{
     ...mapState([
       'groups','appSettings','group',
       ]),
       computeUserAccess(){
         if(!this.group.authorized){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       }
  },
  components: {
    PagePadding,
    ButtonAction,
    ListCalendar,
    ScrollPage
  },
  methods:{
    
  },// methods{}
  created(){
    // get calender_id for group
    this.cal_id=this.group.cal_id;
  },
  mounted(){
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
